/**
 * Mises en page (layouts) du Carnet — la personnalisation du Carnet ne gère plus
 * que la disposition. L'ambiance (couleurs/typo) est gérée par le thème GLOBAL
 * (Paramètres / bouton Personnaliser). 5 dispositions distinctes.
 */
export const CARNET_LAYOUTS = [
  { key: "grid", name: "Grille", desc: "Cartes égales en grille — l'affichage classique.", icon: "▦" },
  { key: "gallery", name: "Galerie", desc: "Grandes cartes aérées, façon galerie.", icon: "▢" },
  { key: "columns", name: "Mosaïque", desc: "Colonnes façon Pinterest, hauteurs libres.", icon: "▥" },
  { key: "stack", name: "Colonne", desc: "Une seule colonne centrée, lecture posée.", icon: "▭" },
  { key: "rows", name: "Liste", desc: "Lignes compactes, dense et efficace.", icon: "☰" },
];

/** Styles de conteneur + extras de carte selon la disposition choisie. */
export function layoutStyles(layout) {
  switch (layout) {
    case "gallery":
      return { gridStyle: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(380px, 1fr))", gap: 20 }, cardExtra: { padding: "22px 24px" } };
    case "columns":
      return { gridStyle: { columnWidth: 300, columnGap: 16 }, cardExtra: { breakInside: "avoid", WebkitColumnBreakInside: "avoid", marginBottom: 16, display: "inline-block", width: "100%" } };
    case "stack":
      return { gridStyle: { display: "flex", flexDirection: "column", gap: 16, maxWidth: 760, margin: "0 auto" }, cardExtra: {} };
    case "rows":
      return { gridStyle: { display: "flex", flexDirection: "column", gap: 10 }, cardExtra: { padding: "12px 16px" } };
    case "grid":
    default:
      return { gridStyle: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 14 }, cardExtra: {} };
  }
}
